export const getSuggestionEmail = (input: string): string => {
  const raw = input.trim();
  if (!raw) return '';

  // No spaces allowed
  if (/\s/.test(raw)) return '';

  // Only allow valid email characters
  const INVALID_CHAR_REGEX = /[^A-Za-z0-9._+-@]/;
  if (INVALID_CHAR_REGEX.test(raw)) return '';

  const atIndex = raw.indexOf('@');

  // More than one "@"
  if (raw.indexOf('@', atIndex + 1) !== -1) return '';

  // Cannot start with "@"
  if (atIndex === 0) return '';

  // No "@" → auto complete with gmail
  if (atIndex === -1) {
    return `${raw}@gmail.com`;
  }

  // Ends with "@"
  if (atIndex === raw.length - 1) {
    return `${raw.slice(0, atIndex)}@gmail.com`;
  }

  const [local, domain] = raw.split('@');

  // Local part validation
  if (
    !local ||
    local.startsWith('.') ||
    local.endsWith('.') ||
    local.includes('..')
  ) {
    return '';
  }

  /**
   * ✅ NEW: smart gmail completion
   * If domain looks like a partial "gmail"
   */
  if (/^gmai?l?$/i.test(domain)) {
    return `${local}@gmail.com`;
  }

  // Domain part validation
  if (
    !domain ||
    domain.startsWith('.') ||
    domain.endsWith('.') ||
    domain.includes('..') ||
    domain.includes('_')
  ) {
    return '';
  }

  // Domain structure validation
  const DOMAIN_REGEX =
    /^[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z0-9]+(-[A-Za-z0-9]+)*)+$/;

  // If domain is already valid → return original
  if (DOMAIN_REGEX.test(domain)) {
    return raw;
  }

  return '';
};
